import { RESOURCE_NAME } from '@esentai/core/features/reconciliationStoreToCp/consts';
import { canCreate, canRead, canUpdate } from '@esentai/core/policy-dsl';

import { authorizeIf } from '@/features/currentUser/rbac';

export const canReadReconciliationStoreToCp = authorizeIf(
  canRead(RESOURCE_NAME),
);
export const canCreateReconciliationStoreToCp = authorizeIf(
  canCreate(RESOURCE_NAME),
);
export const canUpdateReconciliationStoreToCp = authorizeIf(
  canUpdate(RESOURCE_NAME),
);
